import BaseDatePicker, {
  DatePickerProps as BaseDatePickerProps,
} from 'antd/lib/date-picker'
import locale from 'antd/lib/date-picker/locale/ja_JP'
import 'moment/locale/ja'

export type DatePickerProps = Omit<BaseDatePickerProps, 'locale' | 'showTime'>

export const DatePicker = ({
  picker = 'date',
  ...props
}: DatePickerProps): JSX.Element => (
  <>
    <BaseDatePicker locale={locale} picker={picker} {...props} />
  </>
)
